import { createSlice } from '@reduxjs/toolkit'

const linkedPassport = {
  attributes: {
    first_name_passport: '',
    last_name_passport: '',
    relation: '',
    passport_number: ''
  },
  files: [{}],
  valid: {
    first_name_passport: '',
    last_name_passport: '',
    passport_number: '',
    relation: ''
  },
  invalid: {
    first_name_passport: '',
    last_name_passport: '',
    passport_number: '',
    relation: ''
  },
  validation_messages: {
    first_name_passport: '',
    first_name_passport: '',
    passport_number: '',
    relation: ''
  }
}
const paymentMethod = {
  attributes: {
    currency: '',
    payment_type: '',
    first_name: '',
    last_name: '',
    card_type: '',
    amount: '',
    card_number: '',
    last_digits: '',
    exchange_rate: '',
    date_of_transaction: '',
    customer_name_present: '',
    aut: '',
    verified: false,
    ocr: {
      aut: {
        ocr: 0,
        manual: 0,
        score: ''
      },
      amount: {
        ocr: 0,
        manual: 0,
        score: ''
      },

      date_of_transaction: {
        ocr: 0,
        manual: 0,
        score: ''
      },
      last_digits: {
        ocr: 0,
        manual: 0,
        score: ''
      },
      currency: {
        ocr: 0,
        manual: 0,
        score: ''
      }
    },
    verify: {
      currency: false,
      payment_type: false,
      exist_card_number: false,
      date_of_transaction: false,
      last_digits: false,
      aut: false,
      amount: false,
      exchange_rate: false,
      customer_name_present: false
    }
  },
  files: {
    card: [],
    slip: []
  },
  valid: {
    currency: '',
    payment_type: '',
    card_number: '',
    date_of_transaction: '',
    amount: '',
    last_digits: '',
    aut: '',
    exchange_rate: '',
    customer_name_present: ''
  },
  invalid: {
    currency: '',
    payment_type: '',
    card_number: '',
    date_of_transaction: '',
    amount: '',
    last_digits: '',
    aut: '',
    exchange_rate: '',
    customer_name_present: ''
  },
  validation_messages: {
    currency: '',
    payment_type: '',
    card_number: '',
    date_of_transaction: '',
    amount: '',
    last_digits: '',
    aut: '',
    exchange_rate: '',
    customer_name_present: ''
  },
  linked_passport: linkedPassport
}

const purchaseReceipt = {
  attributes: {
    id: '',
    iva: 16,
    date_of_purchase: '',
    currency: '',
    invoice_no: '',
    sub_total: '',
    tax: '',
    refund_to_customer: '',
    service_charges: '',
    dollar_total: '',
    exchange_rate: '',
    total_purchase: '',
    verified: false,
    entered_mxn_total: '',
    factura_verified: '0',
    is_factura_overrided: '0',
    is_factura_desputed: '0',
    seller_address: '',
    rfc_mismatched: "0",
    ocr: {
      invoice_no: {
        ocr: 0,
        manual: 0,
        score: ''
      },
      date_of_purchase: {
        ocr: 0,
        manual: 0,
        score: ''
      },
      exchange_rate: {
        ocr: 0,
        manual: 0,
        score: ''
      }
    },
    verify: {
      currency: false,
      merchant_name: false,
      date_of_purchase: false,
      invoice_no: false,
      sub_total: false,
      iva: false,
      tax: false,
      refund_to_customer: false,
      service_charges: false,
      dollar_total: false,
      exchange_rate: false,
      total_purchase: false
    }
  },
  valid: { date_of_purchase: '', invoice_no: '', currency: '' },
  inValid: { date_of_purchase: '', invoice_no: '', currency: '' },
  validation_messages: { date_of_purchase: '', invoice_no: '', currency: '' },
  items: [],
  payment_methods: [paymentMethod],
  purchase_others: [],
  files: {
    pos_receipt: [],
    sat_invoice: []
    // NOTE: purchase_stamp is created lazily when needed by reducers
  }
}

const initialState = {
  pr: [purchaseReceipt],
  linked_passport: [],
  affiliatesData: {
    affiliates: [],
    regions: [],
    locations: []
  },
  haveAffiliatesData: false,
  activePurchaseTab: 0
}

export const purchaseReceiptSlice = createSlice({
  name: 'purchase_receipts',
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    initializePurchaseReceipt: (state, action) => {
      state = initialState
      return state
    },
    addPurchaseRequest: (state, action) => {
      state.pr.push(purchaseReceipt)
      return state
    },
    addPR: (state, action) => {
      const newPurchaseReceipt = {
        ...purchaseReceipt,
        attributes: {
          ...purchaseReceipt.attributes,
          id: action?.payload?.id || ''
        }
      }
      const prIndex = action?.payload?.index
      const updatedPRArray = [...state.pr]
      updatedPRArray[prIndex] = { ...newPurchaseReceipt }
      return {
        ...state,
        pr: updatedPRArray
      }
    },
    setCCSlip: (state, action) => {
      const newCCSlip = {
        ...paymentMethod,
        attributes: {
          ...paymentMethod.attributes,
          id: action?.payload?.id || ''
        }
      }
      const pr_no = action?.payload?.pr_no
      const ccSlipIndex = action?.payload?.index

      if (state.pr[pr_no]) {
        const updatedPaymentMethods = [...state.pr[pr_no].payment_methods]
        updatedPaymentMethods[ccSlipIndex] = newCCSlip

        // Update the `pr` array with the modified payment methods
        return {
          ...state,
          pr: state.pr.map((prItem, index) =>
            index === pr_no
              ? { ...prItem, payment_methods: updatedPaymentMethods }
              : prItem
          )
        }
      } else {
        console.error('Invalid pr_no or payment_methods not found.')
        return state
      }
    },
    setHaveAffiliatesData: (state, action) => {
      state.haveAffiliatesData = action.payload
    },
    removePurchaseRequest: (state, action) => {
      state.pr.splice(action.payload.pr_no, 1)
      return state
    },
    setPurchaseReceiptAttributes: (state, action) => {
      if (state.pr && state.pr[action.payload.pr_no]) {
        state.pr[action.payload.pr_no].attributes = {
          ...state.pr[action.payload.pr_no].attributes,
          ...action.payload?.attributes
        }
      }
      return state
    },
    addItem: (state, action) => {
      state.pr[action.payload.pr_no].items.push({ id: '' })
      return state
    },
    addItemWithData: (state, action) => {
      state.pr[action.payload.pr_no].items.push({
        ...action.payload.item
      })
      return state
    },
    removeItem: (state, action) => {
      state.pr[action.payload.pr_no].items.splice(action.payload.item_no, 1)
      return state
    },
    removeItemById: (state, action) => {
      const { pr_no, item_id } = action.payload
      if (state.pr?.[pr_no]?.items) {
        state.pr[pr_no].items = state.pr[pr_no].items.filter(item => {
          const currentId = item?.attributes?.id || item?.id
          return currentId !== item_id
        })
      }
      return state
    },
    setItem: (state, action) => {
      var item = state.pr[action.payload.pr_no].items[action.payload.item_no]
      state.pr[action.payload.pr_no].items[action.payload.item_no] = {
        ...item,
        attributes: {
          ...item.attributes,
          ...action.payload.attributes
        }
      }
      return state
    },
    setBulkItemsAttributes: (state, action) => {
      const { pr_no, attributes } = action.payload
      if (state.pr[pr_no]?.items) {
        state.pr[pr_no].items = state.pr[pr_no].items.map(item => ({
          ...item,
          attributes: {
            ...item.attributes,
            ...attributes
          }
        }))
      }
      return state
    },
    addPOSReceiptFile: (state, action) => {
      state.pr[action.payload.pr_no].files[action.payload.file_type].push({})
      return state
    },

    addPOSReceiptFileWithData: (state, action) => {
      if (
        state?.pr?.[action.payload.pr_no]?.files?.[action.payload.file_type]
          ?.length < 1
      ) {
        state?.pr?.[action.payload.pr_no]?.files?.[
          action.payload.file_type
        ]?.push(action.payload.file)
      }
      return state
    },
    // POS stamp cards and files (multiple cards, one file per card like CC slips)
    addPurchaseStampCard: (state, action) => {
      const { pr_no } = action.payload

      if (!state.pr[pr_no].files.purchase_stamp) {
        state.pr[pr_no].files.purchase_stamp = []
      }

      state.pr[pr_no].files.purchase_stamp.push([])
      return state
    },
    addPurchaseStampFileWithData: (state, action) => {
      const { pr_no, card_no, file } = action.payload

      if (!state.pr[pr_no].files.purchase_stamp) {
        state.pr[pr_no].files.purchase_stamp = []
      }
      if (!state.pr[pr_no].files.purchase_stamp[card_no]) {
        state.pr[pr_no].files.purchase_stamp[card_no] = []
      }

      if (state.pr[pr_no].files.purchase_stamp[card_no].length < 1) {
        state.pr[pr_no].files.purchase_stamp[card_no].push(file)
      }
      return state
    },
    updateDropDown: (state, action) => {
      const { data } = action.payload

      if (data && data.length > 0) {
        return {
          ...state,
          pr: state.pr.map(receipt => {
            const matchedAffiliate = data.find(
              item => item.id === receipt.attributes.id
            )

            if (matchedAffiliate) {
              let store = matchedAffiliate.store
              let location = matchedAffiliate.location

              if (matchedAffiliate?.location) {
                const parts = matchedAffiliate?.location.split('/')
                if (parts.length === 2) {
                  store = parts[0]
                  location = parts[1]
                }
              }

              const selectedAffiliateId = matchedAffiliate.affiliate || ''
              const resolvedMerchantName =
                state.affiliatesData?.affiliates?.find(
                  affiliate => affiliate.id === selectedAffiliateId
                )?.name ||
                receipt.attributes?.merchant_name ||
                ''

              return {
                ...receipt,
                attributes: {
                  ...receipt.attributes,
                  affiliate_company_id: selectedAffiliateId,
                  affiliate_region_id: matchedAffiliate.region || '',
                  affiliate_location_id: location || '',
                  affiliate_store_id: store || '',
                  merchant_name: resolvedMerchantName
                }
              }
            }
            return receipt
          })
        }
      }

      return state
    },
    saveAffiliates: (state, action) => {
      const { affiliates, regions, locations, stores } = action.payload
      state.affiliatesData = {
        affiliates: affiliates || [],
        regions: regions || [],
        locations: locations || [],
        stores: stores || []
      }
    },
    removePOSReceiptFile: (state, action) => {
      state.pr[action.payload.pr_no].files[action.payload.file_type].splice(
        action.payload.file_no,
        1
      )
      return state
    },
    // Remove a single POS stamp image from a specific card
    removePurchaseStampFile: (state, action) => {
      const { pr_no, card_no, file_no } = action.payload
      if (state.pr?.[pr_no]?.files?.purchase_stamp?.[card_no]) {
        state.pr[pr_no].files.purchase_stamp[card_no].splice(file_no, 1)
      }
      return state
    },
    // Remove an entire POS stamp card
    removePurchaseStampCard: (state, action) => {
      const { pr_no, card_no } = action.payload
      if (state.pr?.[pr_no]?.files?.purchase_stamp) {
        state.pr[pr_no].files.purchase_stamp.splice(card_no, 1)
      }
      return state
    },
    setPOSReceiptFile: (state, action) => {
      state.pr[action.payload.pr_no].files[action.payload.file_type][
        action.payload.file_no
      ] = {
        file_obj: action.payload.file_obj,
        base64: action.payload.base64
      }

      return state
    },

    setPOSReceiptFileID: (state, action) => {
      state.pr[action.payload.pr_no].files[action.payload.file_type][
        action.payload.file_no
      ].id = action.payload.id

      if (action.payload.document_revision_id) {
        state.pr[action.payload.pr_no].files[action.payload.file_type][
          action.payload.file_no
        ].file_obj.document_revision_id = action.payload.document_revision_id
      }

      return state
    },
    setPOSOthersFileID: (state, action) => {
      state.pr[action.payload.pr_no].files[action.payload.file_type][
        action.payload.file_no
      ].id = action.payload.id

      if (action.payload.document_revision_id) {
        state.pr[action.payload.pr_no].files[action.payload.file_type][
          action.payload.file_no
        ].file_obj.document_revision_id = action.payload.document_revision_id
      }

      return state
    },
    setPurchasePaymentAttributes: (state, action) => {
      var pp =
        state.pr[action.payload.pr_no].payment_methods[action.payload.pp_no]
          .attributes
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].attributes = { ...pp, ...action.payload.attributes }
      return state
    },
    addCCSlip: (state, action) => {
      const newCCSlip = {
        ...paymentMethod,
        attributes: {
          ...paymentMethod.attributes,
          id: action?.payload?.id || ''
        }
      }

      const pr_no = action?.payload?.pr_no
      const ccSlipIndex = action?.payload?.index

      if (state.pr[pr_no] && state.pr[pr_no].payment_methods) {
        const updatedPaymentMethods = [...state.pr[pr_no].payment_methods]
        updatedPaymentMethods[ccSlipIndex] = newCCSlip

        // Update the `pr` array with the modified payment methods
        return {
          ...state,
          pr: state.pr.map((prItem, index) =>
            index === pr_no
              ? { ...prItem, payment_methods: updatedPaymentMethods }
              : prItem
          )
        }
      } else {
        console.error('Invalid pr_no or payment_methods not found.')
        return state
      }
    },
    setOtherPurchase: (state, action) => {
      var pp =
        state.pr[action.payload.pr_no].purchase_others[action.payload.pp_no]
          .attributes
      state.pr[action.payload.pr_no].purchase_others[
        action.payload.pp_no
      ].attributes = { ...pp, ...action.payload.attributes }
      return state
    },
    addPurchasePayment: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods.push(paymentMethod)
      return state
    },
    addOtherPurchaseFile: (state, action) => {
      state.pr[action.payload.pr_no].purchase_others.push([])
      return state
    },
    addPurchasePaymentWithData: (state, action) => {
      var pm = Object.assign({}, paymentMethod)
      pm.attributes = { ...pm.attributes, ...action.payload.attributes }
      state.pr[action.payload.pr_no].payment_methods.push(pm)

      return state
    },
    removePurchasePayment: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods.splice(
        action.payload.pp_no,
        1
      )
      return state
    },
    removePurchaseOthers: (state, action) => {
      const { pr_no, pp_no } = action.payload
      const removedCardFiles =
        state.pr?.[pr_no]?.purchase_others?.[pp_no] || []
      const removedIds = new Set()
      removedCardFiles.forEach(file => {
        const fileId = file?.file_obj?.id || file?.id
        const revId =
          file?.file_obj?.document_revision_id || file?.document_revision_id
        if (fileId) removedIds.add(fileId)
        if (revId) removedIds.add(revId)
      })

      state.pr[pr_no].purchase_others.splice(pp_no, 1)

      if (
        removedIds.size > 0 &&
        Array.isArray(state.pr?.[pr_no]?.files?.purchase_others)
      ) {
        state.pr[pr_no].files.purchase_others = state.pr[
          pr_no
        ].files.purchase_others.filter(file => {
          const fileId = file?.file_obj?.id || file?.id
          const revId =
            file?.file_obj?.document_revision_id || file?.document_revision_id
          return !removedIds.has(fileId) && !removedIds.has(revId)
        })
      }

      return state
    },
    addPurchasePaymentFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].files[action.payload.file_type].push({})
      return state
    },
    addPurchasePaymentFileWithData: (state, action) => {
      if (
        state?.pr[action?.payload?.pr_no].payment_methods[action?.payload.pp_no]
          .files[action.payload.file_type].length < 1
      ) {
        state.pr[action.payload.pr_no].payment_methods[
          action.payload.pp_no
        ].files[action.payload.file_type].push(action.payload.file)
      }
      return state
    },
    addOtherFileWithData: (state, action) => {
      state.pr[action.payload.pr_no].purchase_others[action.payload.pp_no].push(
        action.payload.file
      )
      return state
    },
    removePurchasePaymentFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].files[action.payload.file_type].splice(action.payload.file_no, 1)
      return state
    },
    removePurchaseOtherFile: (state, action) => {
      state.pr[action.payload.pr_no].purchase_others[
        action.payload.pp_no
      ].splice(action.payload.file_no, 1)
      return state
    },
    removePurchaseOtherFilterFiles: (state, action) => {
      const { id, pr_no, pp_no } = action.payload
      if (state.pr?.[pr_no]?.purchase_others?.[pp_no]) {
        state.pr[pr_no].purchase_others[pp_no] = state.pr[
          pr_no
        ].purchase_others[pp_no].filter(
          item => (item?.file_obj?.id || item?.id) !== id
        )
      }

      if (id && Array.isArray(state.pr?.[pr_no]?.files?.purchase_others)) {
        state.pr[pr_no].files.purchase_others = state.pr[
          pr_no
        ].files.purchase_others.filter(file => {
          const fileId = file?.file_obj?.id || file?.id
          const revId =
            file?.file_obj?.document_revision_id || file?.document_revision_id
          return fileId !== id && revId !== id
        })
      }

      return state
    },
    setPurchasePaymentFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].files[action.payload.file_type][action.payload.file_no] = {
        file_obj: action.payload.file_obj,
        base64: action.payload.base64
      }

      return state
    },
    setPurchaseOthersFile: (state, action) => {
      state.pr[action.payload.pr_no].purchase_others[action.payload.pp_no].push(
        {
          file_obj: action.payload.file_obj,
          base64: action.payload.base64
        }
      )

      return state
    },

    setPurchasePaymentFileID: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].files[action.payload.file_type][action.payload.file_no].id =
        action.payload.id

      if (action.payload.document_revision_id) {
        state.pr[action.payload.pr_no].payment_methods[
          action.payload.pp_no
        ].files[action.payload.file_type][
          action.payload.file_no
        ].file_obj.document_revision_id = action.payload.document_revision_id
      }

      return state
    },
    setPurchaseOtherFileID: (state, action) => {
      state.pr[action.payload.pr_no].purchase_others[
        action.payload.pp_no
      ].files[action.payload.file_type][action.payload.file_no].id =
        action.payload.id

      if (action.payload.document_revision_id) {
        state.pr[action.payload.pr_no].payment_methods[
          action.payload.pp_no
        ].files[action.payload.file_type][
          action.payload.file_no
        ].file_obj.document_revision_id = action.payload.document_revision_id
      }

      return state
    },
    setLinkedPassport: (state, action) => {
      var linked_passport =
        state.pr[action.payload.pr_no].payment_methods[action.payload.pp_no]
          .linked_passport.attributes
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.attributes = {
        ...linked_passport,
        ...action.payload.attributes
      }
      return state
    },
    addLinkedPassportFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.files.push({})
      return state
    },
    addLinkedPassportFileWithData: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.files.push(action.payload.file)
      return state
    },
    removeLinkedPassportFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.files.splice(action.payload.file_no, 1)
      return state
    },
    setLinkedPassportFile: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.files[action.payload.file_no] = {
        file_obj: action.payload.file_obj,
        base64: action.payload.base64
      }

      return state
    },

    setLinkedPassportFileID: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.files[action.payload.file_no].id = action.payload.id

      if (action.payload.document_revision_id) {
        state.pr[action.payload.pr_no].payment_methods[
          action.payload.pp_no
        ].linked_passport.files[
          action.payload.file_no
        ].file_obj.document_revision_id = action.payload.document_revision_id
      }
    },
    setShowLinkedPassport: (state, action) => {
      state.linked_passport[action.payload.pp_no] =
        action.payload.show_passport_card
      return state
    },
    setPurchaseSlipValidity: (state, action) => {
      state.pr[action.payload.pr_no].valid[action.payload.field_name] =
        action.payload.valid
      state.pr[action.payload.pr_no].inValid[action.payload.field_name] =
        action.payload.inValid
      state.pr[action.payload.pr_no].validation_messages[
        action.payload.field_name
      ] = action.payload.message
      return state
    },
    setPMValidity: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].valid[action.payload.field_name] = action.payload.valid
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].invalid[action.payload.field_name] = action.payload.invalid
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].validation_messages[action.payload.field_name] = action.payload.message
      return state
    },

    setLPValidity: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.valid[action.payload.field_name] = action.payload.valid
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.invalid[action.payload.field_name] =
        action.payload.invalid
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].linked_passport.validation_messages[action.payload.field_name] =
        action.payload.message
      return state
    },
    purchaseReceiptVerifyAll: (state, action) => {
      const pr = state.pr[action.payload.pr_no].attributes
      let obj = {}
      if (pr.currency === 'mxn') {
        obj = Object.assign(
          {},
          state.pr[action.payload.pr_no].attributes.verify
        )
        delete obj.dollar_total
        delete obj.exchange_rate
      } else {
        obj = Object.assign(
          {},
          state.pr[action.payload.pr_no].attributes.verify
        )
      }
      const array = Object.keys(obj)
      array.map(value => {
        state.pr[action.payload.pr_no].attributes.verify[value] =
          action.payload.value
      })
      const items_array = state.pr[action.payload.pr_no].items

      if (items_array.length > 0) {
        if (action.payload.older_record == true) {
          items_array.map((obj, i) => {
            obj.cost_verified = action.payload.value
            obj.description_verified = action.payload.value
            obj.qty_verified = action.payload.value
            obj.sat_verified = action.payload.value
          })
        } else {
          items_array.map((obj, i) => {
            obj.cost_verified = action.payload.value
            obj.qty_verified = action.payload.value
            obj.sat_code_number_verified = action.payload.value
            obj.sat_code_category_verified = action.payload.value
          })
        }
      }
      return state
    },
    // The paymentMethodVerifyAll reducer is designed to work with a simple value (true/false) and applies it to filtered fields,
    paymentMethodVerifyAll: (state, action) => {
      const card =
        state.pr[action.payload.pr_no].payment_methods[action.payload.pp_no]
      var obj = {}
      if (
        card.attributes.payment_type == 'cash' &&
        card.attributes.currency == 'usd'
      ) {
        obj = Object.assign({}, card.attributes.verify)
        delete obj.date_of_transaction
        delete obj.last_digits
        delete obj.exist_card_number
      } else if (
        card.attributes.payment_type == 'cash' &&
        card.attributes.currency == 'mxn'
      ) {
        obj = Object.assign({}, card.attributes.verify)
        delete obj.date_of_transaction
        delete obj.last_digits
        delete obj.exist_card_number
        delete obj.exchange_rate
      } else if (card.attributes.payment_type == 'financing') {
        obj = Object.assign({}, card.attributes.verify)
        delete obj.exist_card_number
        delete obj.exchange_rate
      } else if (
        (card.attributes.payment_type == 'credit' ||
          card.attributes.payment_type == 'debit') &&
        card.attributes.currency == 'mxn'
      ) {
        obj = Object.assign({}, card.attributes.verify)
        delete obj.exchange_rate
      } else {
        obj = Object.assign({}, card.attributes.verify)
      }
      const array = Object.keys(obj)
      array.map(value => {
        state.pr[action.payload.pr_no].payment_methods[
          action.payload.pp_no
        ].attributes.verify[value] = action.payload.value
      })

      return state
    },
    setPurchaseRequestsFromAPI: (state, action) => {
      const purchaseRequestsData = action.payload
      if (Array.isArray(purchaseRequestsData)) {
        state.pr = purchaseRequestsData
      }
      return state
    },
    setPurchaseReceiptOcr: (state, action) => {
      state.pr[action.payload.pr_no].attributes.ocr = action.payload.ocr
      return state
    },
    setPurchaseReceiptVerify: (state, action) => {
      state.pr[action.payload.pr_no].attributes.verify = action.payload.verify
      return state
    },
    setPurchasePaymentOcr: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].attributes.ocr = action.payload.ocr
      return state
    },
    setPurchasePaymentVerify: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].attributes.verify = action.payload.verify
      return state
    },

    setTripId: (state, action) => {
      state.tripId = action.payload
    },
    verifyPurchaseItems: (state, action) => {
      const { pr_no, item_no, attributes } = action.payload
      let item = state.pr[pr_no].items[item_no]
      state.pr[pr_no].items[item_no] = {
        ...item,
        ...attributes
      }
      return state
    },
    setPurchaseItemsValidationMessages: (state, action) => {
      const { pr_no, item_no, attributes } = action.payload
      let item = state.pr[pr_no].items[item_no]
      state.pr[pr_no].items[item_no] = {
        ...item,
        ...attributes
      }
      return state
    },
    setItemAttributes: (state, action) => {
      const item = state.pr[action.payload.pr_no].items[action.payload.item_no]
      if (!item.attributes) {
        item.attributes = {}
      }
      item.attributes = { ...item.attributes, ...action.payload.attributes }
      return state
    },
    setActivePurchaseTab: (state, action) => {
      state.activePurchaseTab = action.payload
      return state
    },
    setPurchasePaymentExchangeRate: (state, action) => {
      state.pr[action.payload.pr_no].payment_methods[
        action.payload.pp_no
      ].attributes.exchange_rate = action.payload.exchange_rate
      return state
    },
    setPurchaseRequestsFromAPICustomerModal: (state, action) => {
      const newPurchaseReceipt = {
        ...purchaseReceipt,
        attributes: {
          ...purchaseReceipt.attributes,
          id: action.payload.id ?? '',
          iva: action.payload.iva ?? 16,
          currency: action.payload.currency ?? 'usd',
          quote_id: action.payload.quote_id ?? '',
          trip_id: action.payload.trip_id ?? '',
          date_entered: action.payload.date_entered ?? '',
          date_modified: action.payload.date_modified ?? ''
        }
      }
      state.pr = [newPurchaseReceipt]

      return state
    },
    setPurchasePaymentFromAPICustomerModal: (state, action) => {
      const newPurchasePayment = {
        ...paymentMethod,
        attributes: {
          ...paymentMethod.attributes,
          id: action.payload.id ?? '',
          currency: action.payload.currency ?? 'mxn',
          payment_type: action.payload.payment_type ?? 'credit',
          date_entered: action.payload.date_entered ?? '',
          date_modified: action.payload.date_modified ?? '',
          purchase_request_id: action.payload.purchase_request_id ?? '',
          verified: action.payload.verified ?? false
        }
      }
      state.pr[action.payload.pr_no].payment_methods = [newPurchasePayment]
      return state
    }
  }
})

export const {
  setPurchaseReceiptAttributes,
  paymentMethodVerifyAll,
  purchaseReceiptVerifyAll,
  addItem,
  removeItem,
  removeItemById,
  setItem,
  setBulkItemsAttributes,
  initializePurchaseReceipt,
  addPurchaseRequest,
  addPR,
  addCCSlip,
  setCCSlip,
  removePurchaseRequest,
  setHaveAffiliatesData,
  addPOSReceiptFile,
  removePOSReceiptFile,
  setPOSReceiptFile,
  setPurchasePaymentAttributes,
  addPurchasePayment,
  removePurchasePayment,
  addPurchasePaymentFile,
  removePurchasePaymentFile,
  setPurchasePaymentFile,
  setLinkedPassport,
  addLinkedPassportFile,
  removeLinkedPassportFile,
  setLinkedPassportFile,
  setPOSReceiptFileID,
  setPOSOthersFileID,
  setLinkedPassportFileID,
  setPurchasePaymentFileID,
  setOtherPurchase,
  setShowLinkedPassport,
  setPMValidity,
  setPurchaseSlipValidity,
  setLPValidity,
  addItemWithData,
  addPurchasePaymentWithData,
  addPOSReceiptFileWithData,
  updateDropDown,
  saveAffiliates,
  addPurchaseStampCard,
  addPurchaseStampFileWithData,
  addPurchasePaymentFileWithData,
  addLinkedPassportFileWithData,
  addOtherPurchaseFile,
  addOtherFileWithData,
  removePurchaseOtherFile,
  removePurchaseOtherFilterFiles,
  removePurchaseOthers,
  removePurchaseStampFile,
  removePurchaseStampCard,
  setPurchaseOthersFile,
  setPurchaseOtherFileID,
  setPurchaseRequestsFromAPI,
  setTripId,
  setPurchaseReceiptOcr,
  setPurchaseReceiptVerify,
  setPurchasePaymentOcr,
  setPurchasePaymentVerify,
  verifyPurchaseItems,
  setPurchaseItemsValidationMessages,
  setItemAttributes,
  setActivePurchaseTab,
  setPurchasePaymentExchangeRate,
  setPurchaseRequestsFromAPICustomerModal,
  setPurchasePaymentFromAPICustomerModal
} = purchaseReceiptSlice.actions
export const selectPosReceiptFiles = state =>
  state?.purchaseReceipt?.pr?.[0]?.files?.pos_receipt || []
export const selectSatInvoiceFiles = state =>
  state?.purchaseReceipt?.pr?.[0]?.files?.sat_invoice || []

export const selectCreditCardSlipFiles = state =>
  state?.purchaseReceipt?.pr?.[0]?.payment_methods?.[0]?.files?.slip || []

export const selectActivePurchaseTab = state =>
  state?.purchaseReceipt?.activePurchaseTab || 0

export default purchaseReceiptSlice.reducer
